<mat-card [style.background]="cardColor" *ngIf="entityType !== 'WorkerPermitLicense'">
    <mat-card-content>
      <mat-card-title>
          <h4>Non-Refundable {{ paymentService.getPaymentTypeDescription(entityType, feeType, renewal) }} :
          <span *ngIf="entityType != null && entityType.length > 0">
            ${{paymentService.getPaymentTypeAmount(entityType, feeType, renewal, amount)}}
          </span></h4>
      </mat-card-title>
      <div class="flex flex-col gap-4 f-s-16">

        <span style="white-space: pre-wrap">
          {{paymentService.getPaymentTypeNotice(entityType, feeType, renewal)}}
        </span>

        <div *ngIf="feeType == 'CivilPenaltyFee'">
<span>Payment method options:</span>
        <ul>
          <li><span *ngIf="!canPay">Pay Online (fastest option)</span> <span *ngIf="canPay"><a (click)="pay()" >Pay Online (fastest option)</a></span></li>
          <li>Money Order</li>
          <li>Cashier's Check</li>
          <li>Personal/Business Check (held for 21 days for clearance)</li>
          <li>Cash (in-person only; <strong>do NOT mail</strong>)</li>
        </ul>
<br>
        <div class="flex flex-row justify-center items-start">
          <span><strong>Instructions for Payment</strong></span>
        </div>
<br>
        <div>
          <strong>Reminder:</strong>
          Use the Civil Penalty Remittance Slip for all in-person or mailed payments to ensure proper crediting.
        </div>
<br>
        <div class="flex flex-col">
          <div><strong>By Mail</strong></div>
          <div>Make money orders and checks payable to: <strong>Oregon Psilocybin Services</strong></div>
          <div>Mail payment and Civil Penalty Remittance Slip to:</div>
          <div>Oregon Health Authority - Public Health Division - Fiscal Services</div>
          <div>RE: OPS</div>
          <div>PO Box 14260</div>
          <div>Portland, OR 97293-0260</div>
        </div>
<br>
        <div class="flex flex-col">
          <div><strong>In-person</strong></div>
          <div>Bring your payment and printed remittance slip to:</div>
          <div><strong>Cashier's Office</strong></div>
          <div>Portland State Office Building</div>
          <div>800 NE Oregon St, Suite 200, Portland, OR 97232</div>
          <div>Hours: Monday-Friday, 9 AM-4 PM</div>
          <div>Located next to the Vital Health Statistics window. No appointment required.</div>
        </div>
<br>
        <div class="flex flex-col">
          <div><strong>Important Information</strong></div>
          <ul>
            <li>Civil penalties are <strong>non-refundable.</strong></li>
            <li>The <strong>amount due</strong> and <strong>due dates</strong> can be found in your <strong>Final Order</strong>.</li>
            <li>Money orders and cashier’s checks clear faster than personal/business checks.</li>
            <li>Ensure your payment clears before the payment deadline listed in your Final Order.</li>
            <li>Cash payments require an appointment.</li>
          </ul>
        </div>
<br>
        <div class="flex flex-col">
          <span><strong>Questions or Cash Payment Arrangements:</strong></span>
          <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">
            Email:<a href="mailto:licensing.psilocybin@oha.oregon.gov">
              <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                <span>licensing.psilocybin&#64;oha.oregon.gov</span>
              </div></a>
          </div>
          <div>Phone: 971-673-0304</div>
        </div>
        </div>

        <div *ngIf="feeType != 'CivilPenaltyFee'">

          <span>Payment method options:</span>
          <ul>
            <li><span *ngIf="!canPay">Online</span> <span *ngIf="canPay"><a (click)="pay()" >Pay online </a></span></li>
            <li>Money Order</li>
            <li>Cashier's Check</li>
            <li>Personal/Business Check (personal and business checks are held for 21 days for clearance)</li>
            <li>Cash* <strong>Please Do Not Mail Cash</strong></li>
          </ul>

          <div *ngIf="!renewal" class="flex flex-row justify-center items-start">
            <span><strong>Instructions for Submitting the Fee Payment by Mail or In-Person</strong></span>
          </div>

          <div *ngIf="renewal" class="flex flex-row justify-center items-start">
            <span><strong>Instructions for Submitting the Fee Payment by Mail or In-Person</strong></span>
          </div>

          <span *ngIf="!renewal">
            Money orders and checks are payable to: <strong>Oregon Psilocybin Services</strong>
            Money orders and cashier's checks take less time to clear than personal and business checks.
            Personal and business checks are held for 21 days for clearance. Applications will be reviewed
            once payment has been cleared. Application fees are non-refundable.
          </span>

          <span *ngIf="renewal">
            Money orders and checks are payable to: <strong>Oregon Psilocybin Services</strong>
            Money orders and cashier's checks take less time to clear than personal and business checks.
            Personal and business checks are held for 21 days for clearance. Renewal license fees are non-refundable.
          </span>

          <div class="flex flex-col">
            <span>
              <strong *ngIf="!renewal">Mailing the application packet, money order or check, and remittance form:</strong>
              <strong *ngIf="renewal">Mailing the renewal application packet, money order or check, and remittance form:</strong>
            </span>
            <span>Oregon Health Authority - Public Health Division - Fiscal Services</span>
            <span>RE: OPS</span>
            <span>PO Box 14260</span>
            <span>Portland, OR 97293-0260</span>
          </div>

          <div class="flex flex-col">
            <span><strong>In-person payment with a money order or check:</strong></span>
            <span>
              To make an in-person fee payment with a money order or check, print the remittance form and proceed to
              Cashier's Office on the second floor of the Portland State Office Building at 800 NE Oregon St, Suite 200,
              Portland, OR 97232 - Hours: 9am to 4pm, Mon to Fri
            </span>
          </div>

          <span>
            Additional instructions: The Cashier's Office window is located on the second floor next to the Vital Health Statistics window.
            If security asks if you have an appointment, you may let them know you are dropping off a payment for Oregon Psilocybin Services
            at the Cashier's Office window which does not require an appointment. Please include the remittance form with the payment.
          </span>

          <div class="flex flex-col">
            <span><strong>To make cash payment arrangements or for payment questions, please contact:</strong></span>
            <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">
              <a href="mailto:licensing.psilocybin@oha.oregon.gov ">
                <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                  <span>
                    licensing.psilocybin&#64;oha.oregon.gov </span>
                  <mat-icon>email</mat-icon>
                </div>
              </a>
              <span>or Licensing Inquiries: 1-971-673-0304</span>
            </div>
          </div>


        </div>


        <div *ngIf="entityType === 'FacilitatorLicense' && !renewal && feeType != 'CivilPenaltyFee'" class="flex flex-col gap-4">
          <h3>Non-Refundable Facilitator Annual License Fee: $2,000 or $1,000 if Applicant Qualifies for Reduced License Fee:
          </h3>
          <span>
            If your license application is approved, pending license fee payment and clearance, you will receive a request to pay the annual licensing fee.
            Please review the guide for more detailed information on reduced fees. To request a reduced fee, please upload the required supporting document in
            the “Documents” tab of this application. If you qualify for a reduced license fee, the fee will be reduced accordingly. Please use the same payment instructions
            above to pay the annual license fee.
            <strong>
              A license will not be issued until the annual license fee is paid and cleared. A licensee may not operate until the effective date of licensure.
            </strong>
          </span>
        </div>
        <div *ngIf="entityType === 'ManufacturerLicense' && !renewal && feeType != 'CivilPenaltyFee'" class="flex flex-col gap-4">
          <h3>Non-Refundable Manufacturer Annual License Fee: $10,000 or $5,000 if Applicant Qualifies for Reduced Fee
          </h3>
          <span>
            If your license application is approved, pending license fee payment and clearance, you will receive a request to pay the annual licensing fee.
            Please review the guide for more detailed information on reduced fees. To request a reduced fee, please upload the required supporting document in
            the “Documents” tab of this application. If you qualify for a reduced license fee, the fee will be reduced accordingly. Please use the same payment instructions
            above to pay the annual license fee.
            <strong>
              A license will not be issued until the annual license fee payment is paid and cleared. A licensee may not operate until the effective date of licensure.
            </strong>
          </span>
        </div>
        <div *ngIf="entityType === 'ServiceCenterLicense' && !renewal && feeType != 'CivilPenaltyFee'" class="flex flex-col gap-4">
          <h3>Non-Refundable Service Center Annual License Fee: $10,000 or $5,000 if Applicant Qualifies for Reduced License Fee
          </h3>
          <span>
            If your license application is approved, pending license fee payment and clearance, you will receive a request to pay the annual licensing fee.
            Please review the guide for more detailed information on reduced fees. To request a reduced fee, please upload the required supporting
            document in the “Documents” tab of this application. If you qualify for a reduced license fee, the fee will be reduced accordingly.
            Please use the same payment instructions above to pay the annual license fee. <strong>A license will not be issued until the annual license fee
            payment has been paid and cleared. A licensee may not operate until the effective date of licensure.</strong>
          </span>
        </div>
        <div *ngIf="entityType === 'TestingLabLicense' && !renewal && feeType != 'CivilPenaltyFee'" class="flex flex-col gap-4">
          <h3>Non-Refundable Laboratory Annual License Fee: $10,000
          </h3>
          <span>
            If your license application is approved, pending license fee payment and clearance, you will receive a request to pay the annual licensing fee.
            Please use the same payment instructions above to pay the annual license fee. <strong>A license will not be issued until the annual license fee
            payment is paid and cleared. A licensee may not operate until the effective date of licensure. </strong>
          </span>
        </div>
        <div *ngIf="canPay" class="flex flex-col gap-2">
          <div>
            <button *ngIf="!sharedService.mobile && feeType == 'CivilPenaltyFee'" mat-raised-button color="primary" type="button" (click)="viewRemittanceSlip()">View Civil Penalty Remittance Slip</button>
            <button *ngIf="!sharedService.mobile && feeType != 'CivilPenaltyFee'" mat-raised-button color="primary" type="button" (click)="viewRemittanceSlip()">View Remittance Slip</button>
          </div>
          <div>
            <button mat-stroked-button type='button' (click)="pay()" color="primary" *ngIf="canPay">Pay Online Now</button>
          </div>
          <span *ngIf="sharedService.mobile"><strong>Remittance Slip Not Available on Mobile</strong></span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="entityType === 'WorkerPermitLicense' && feeType !== 'CivilPenaltyFee'">
    <mat-card-title>
      <h4>
      <span *ngIf="!renewal">Non-Refundable Worker Permit Fee $25.00</span>
      <span *ngIf="renewal">Non-Refundable Worker Permit Renewal Fee $25.00</span></h4>
    </mat-card-title>
    <mat-card-content>
      <div class="flex flex-col gap-2 f-s-16">
        <span *ngIf="!renewal">
          After the worker permit application has been approved, pending worker permit fee payment and clearance,
          you will receive a request to pay the worker permit fee. At that time, we will provide a permit fee remittance
          form to submit with your permit fee payment. A worker permit will not be issued until the worker permit fee is
          paid and cleared. If issued a worker permit, an individual may not perform the duties described in ORS 475A.445
          until the effective date of approval.
        </span>
        <span *ngIf="renewal">
          After the worker permit renewal application has been approved, pending worker permit fee payment and clearance,
          you will receive a request to pay the worker permit renewal fee. At that time, we will provide a permit fee remittance
          form to submit with your permit renewal fee payment. A worker permit will not be renewed until the fee is
          paid and cleared. An individual may not perform the duties described in ORS 475A.445 without an approved worker permit.
        </span>
        <span *ngIf="renewal">
          Please Note: If payment is not submitted within 30 days from the date that you received notice that your renewal application has been moved to "renewal approved pending payment and clearance" status, your renewal application will be closed due to non-payment.
        </span>

        <div *ngIf="renewal" class="flex flex-col gap-4">
          <span>Payment method options:</span>
          <ul>
            <li>Online</li>
            <li>Money Order</li>
            <li>Cashier's Check</li>
            <li>Personal/Business Check (personal and business checks are held for 21 days for clearance)</li>
            <li>Cash* <strong>Please Do Not Mail Cash</strong></li>
          </ul>

          <div *ngIf="renewal" class="flex flex-row justify-center items-start">
            <span><strong>Instructions for Submitting the Fee Payment by Mail or In-Person</strong></span>
          </div>

          <span *ngIf="renewal">
            Money orders and checks are payable to: <strong>Oregon Psilocybin Services</strong>
            Money orders and cashier's checks take less time to clear than personal and business checks.
            Personal and business checks are held for 21 days for clearance. Renewal applications will be reviewed
            once payment has been cleared. Renewal application fees are non-refundable.
          </span>

          <div class="flex flex-col">
            <span>
              <strong *ngIf="renewal">Mailing the renewal application packet, money order or check, and remittance form:</strong>
            </span>
            <span>Oregon Health Authority - Public Health Division - Fiscal Services</span>
            <span>RE: OPS</span>
            <span>PO Box 14260</span>
            <span>Portland, OR 97293-0260</span>
          </div>

          <div class="flex flex-col">
            <span><strong>In-person payment with a money order or check:</strong></span>
            <span>
              To make an in-person fee payment with a money order or check, print the remittance form and proceed to Cashier's Office on the second floor of the Portland State Office
              Building at 800 NE Oregon St, Suite 200, Portland, OR 97232 - Hours: 9am to 4pm, Mon to Fri
            </span>
          </div>

          <span>
            Additional instructions: The Cashier's Office window is located on the second floor next to the Vital Health Statistics window.
            If security asks if you have an appointment, you may let them know you are dropping off a payment for Oregon Psilocybin Services at the Cashier's Office
            window which does not require an appointment. Please include the remittance form with the payment.
          </span>

          <div class="flex flex-col">
            <span><strong>To make cash payment arrangements or for payment questions, please contact:</strong></span>
            <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">
              <a href="mailto:licensing.psilocybin@oha.oregon.gov ">
                <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                  <span>
                    licensing.psilocybin&#64;oha.oregon.gov </span>
                  <mat-icon>email</mat-icon>
                </div>
              </a>
              <span>or Licensing Inquiries: 1-971-673-0304</span>
            </div>
          </div>
        </div>

        <span style="color:red">
          <strong *ngIf="!renewal">
            Do not send the permit fee payment until contacted by OPS that your application has been approved and you
            receive payment instructions.
          </strong>
          <strong *ngIf="renewal">
            Do not send the permit renewal fee payment until contacted by OPS that your application has been approved and you
            receive payment instructions.
          </strong>
        </span>


        <div class="flex flex-col" *ngIf="!renewal">
          <span><strong>If you have any questions, please send us a TLC message or email/call: </strong></span>
          <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">
            <a href="mailto:licensing.psilocybin@oha.oregon.gov ">
              <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                <span>
                  licensing.psilocybin&#64;oha.oregon.gov </span>
                <mat-icon>email</mat-icon>
              </div>
            </a>
            <span>or (971) 673-0304</span>
          </div>
        </div>


        <div *ngIf="canPay" class="flex flex-col gap-2">
          <div>
            <button *ngIf="!sharedService.mobile" mat-raised-button color="primary" type="button" (click)="viewRemittanceSlip()">View Remittance Slip</button>
          </div>
          <div>
            <button mat-stroked-button type='button' (click)="pay()" color="primary" *ngIf="canPay">Pay Online Now</button>
          </div>
          <span *ngIf="sharedService.mobile"><strong>Remittance Slip Not Available on Mobile</strong></span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

    <mat-card *ngIf="entityType === 'WorkerPermitLicense' && feeType == 'CivilPenaltyFee'">
       <mat-card-content>
      <mat-card-title>
          <h4>Non-Refundable {{ paymentService.getPaymentTypeDescription(entityType, feeType, renewal) }} :
          <span *ngIf="entityType != null && entityType.length > 0">
            ${{paymentService.getPaymentTypeAmount(entityType, feeType, renewal, amount)}}
          </span></h4>
      </mat-card-title>
      <div class="flex flex-col gap-4 f-s-16">

        <span style="white-space: pre-wrap">
          {{paymentService.getPaymentTypeNotice(entityType, feeType, renewal)}}
        </span>

        <div *ngIf="feeType == 'CivilPenaltyFee'">
          <span>Payment method options:</span>
          <ul>
            <li><span *ngIf="!canPay">Pay Online (fastest option)</span> <span *ngIf="canPay"><a (click)="pay()" >Pay Online (fastest option)</a></span></li>
            <li>Money Order</li>
            <li>Cashier's Check</li>
            <li>Personal/Business Check (held for 21 days for clearance)</li>
            <li>Cash (in-person only; <strong>do NOT mail</strong>)</li>
          </ul>
<br>
        <div class="flex flex-row justify-center items-start">
          <span><strong>Instructions for Payment</strong></span>
        </div>
<br>
        <div>
          <strong>Reminder:</strong>
          Use the Civil Penalty Remittance Slip for all in-person or mailed payments to ensure proper crediting.
        </div>
<br>
        <div class="flex flex-col">
          <div><strong>By Mail</strong></div>
          <div>Make money orders and checks payable to: <strong>Oregon Psilocybin Services</strong></div>
          <div>Mail payment and Civil Penalty Remittance Slip to:</div>
          <div>Oregon Health Authority - Public Health Division - Fiscal Services</div>
          <div>RE: OPS</div>
          <div>PO Box 14260</div>
          <div>Portland, OR 97293-0260</div>
        </div>
<br>
        <div class="flex flex-col">
          <div><strong>In-person</strong></div>
          <div>Bring your payment and printed remittance slip to:</div>
          <div><strong>Cashier's Office</strong></div>
          <div>Portland State Office Building</div>
          <div>800 NE Oregon St, Suite 200, Portland, OR 97232</div>
          <div>Hours: Monday-Friday, 9 AM-4 PM</div>
          <div>Located next to the Vital Health Statistics window. No appointment required.</div>
        </div>
<br>
        <div class="flex flex-col">
          <div><strong>Important Information</strong></div>
          <ul>
            <li>Civil penalties are <strong>non-refundable.</strong></li>
            <li>The <strong>amount due</strong> and <strong>due dates</strong> can be found in your <strong>Final Order</strong>.</li>
            <li>Money orders and cashier’s checks clear faster than personal/business checks.</li>
            <li>Ensure your payment clears before the payment deadline listed in your Final Order.</li>
            <li>Cash payments require an appointment.</li>
          </ul>
        </div>
<br>
        <div class="flex flex-col">
          <span><strong>Questions or Cash Payment Arrangements:</strong></span>
          <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">
            Email:<a href="mailto:licensing.psilocybin@oha.oregon.gov">
              <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                <span>licensing.psilocybin&#64;oha.oregon.gov</span>
              </div></a>
          </div>
          <div>Phone: 971-673-0304</div>
        </div>
        </div>

        <div *ngIf="canPay" class="flex flex-col gap-2">
          <div>
            <button *ngIf="!sharedService.mobile && feeType == 'CivilPenaltyFee'" mat-raised-button color="primary" type="button" (click)="viewRemittanceSlip()">View Civil Penalty Remittance Slip</button>
            <button *ngIf="!sharedService.mobile && feeType != 'CivilPenaltyFee'" mat-raised-button color="primary" type="button" (click)="viewRemittanceSlip()">View Remittance Slip</button>
          </div>
          <div>
            <button mat-stroked-button type='button' (click)="pay()" color="primary" *ngIf="canPay">Pay Online Now</button>
          </div>
          <span *ngIf="sharedService.mobile"><strong>Remittance Slip Not Available on Mobile</strong></span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
